import React from 'react'
import { createIcon } from '@chakra-ui/icon'

export const CheckIcon = createIcon({
  displayName: 'CheckIcon',
  path: <path d="M8.795 15.875l-4.17-4.17-1.42 1.41 5.59 5.59 12-12-1.41-1.41-10.59 10.58z" fill="currentColor" />,
  viewBox: '0 0 24 24',
})
